<template>
  <div class="login">
    <a-row>
      <a-col :xs="24" :sm="24" :lg="{ span: 8, offset: 8 }" class="centered">
        <a-card class="login-card w-full">
          <a-form
            id="components-form-demo-normal-login"
            :form="form"
            class="login-form"
            @submit="login"
          >
            <a-form-item>
              <a-input
                v-decorator="[
                  'email',
                  { rules: [{ required: true, message: $t('login.emailerror') }] }
                ]"
                placeholder="Email"
              >
                <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input
                v-decorator="[
                  'password',
                  { rules: [{ required: true, message: $t('login.pwderror') }] }
                ]"
                type="password"
                placeholder="Password"
              >
                <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-button
                type="primary"
                html-type="submit"
                :loading="this.logginIn"
                class="login-form-button"
              >
                {{ $t('login.login') }}
              </a-button>
            </a-form-item>
          </a-form>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import api from '@/api.js';

export default {
  name: 'login',
  components: {},
  data: function() {
    return {
      logginIn: false
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'login' });
    this.formForgot = this.$form.createForm(this, { name: 'forgot' });
  },
  mounted: async function() {
    // let rt = localStorage.getItem('i4m_refresh_token');
    // if (rt) {
    //   // await api.refreshToken({ refresh_token: rt, grant_type: 'refresh_token' });
    // }
  },
  computed: {
    loginEsit: function() {
      return this.$store.state.loginEsit;
    }
  },
  watch: {
    loginEsit: function(newVal, oldVal) {
      if (newVal == 'ko' && newVal !== oldVal) {
        this.showFailedLoginNotification();
        this.form.setFields({
          password: {
            value: ''
          }
        });
      }

      if (newVal == 'ok' && newVal !== oldVal) {
        this.$router.replace(this.$store.state.redirectAfterLogin || '/');
        this.$store.commit('setRedirectAfterLogin', null);

        this.$notification.success({
          message: this.$t('login.success'),
          duration: 5
        });

        this.$notification.destroy();
      }
    }
  },
  methods: {
    async login(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (err) return;

        this.logginIn = true;

        try {
          await api.login({ email: values.email, password: values.password });
          this.$store.commit('setBrokerLoggedIn', true);
          this.$router.replace({ name: 'broker-orders' });
        } catch (e) {
          console.log('Error loggin in');
          this.logginIn = false;
          return this.showFailedLoginNotification();
        }

        this.logginIn = false;
      });
    },

    showFailedLoginNotification() {
      this.$notification.error({
        message: this.$t('login.loginfailed'),
        duration: 0,
        description: this.$t('login.loginfaileddesc')
      });
    }
  }
};
</script>
<style lang="scss">
@import '@/variables.scss';
.login {
  padding-top: 4rem;
}

.login-card {
  margin: 1rem;

  @media #{$lg} {
    max-width: 400px;
  }
}

.login-form-button {
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 0.75rem;
  }
}
</style>
